import React from 'react';
import styled from 'styled-components';

import Button from '../components/global/button';

const HeroStyle = styled.div`
	background-image: url(${(p) => p.bimg});
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 29rem;

	.text-container {
		text-align: center;
		color: #fff;

		h1,
		h2 {
			padding: 0 2rem;
		}

		h2 {
			font-family: ${(p) => p.theme.fonts.body};
			font-weight: 600;
			font-size: 3rem;
			line-height: 4rem;
			text-transform: uppercase;
			letter-spacing: 0.025em;
		}

		.toptext {
			margin-bottom: 0.5rem;
		}

		.subtext {
			margin: 0.5rem 0 2rem;
		}

		@media all and (max-width: 550px) {
			h1,
			h2 {
				font-size: 2.5rem;
				line-height: 3rem;
			}
		}
	}
`;
export default ({ bimg, title, subtext, toptext, cta }) => {
	return (
		<HeroStyle bimg={bimg} className="hero">
			<div className="text-container">
				{toptext && <p className="toptext">{toptext}</p>}
				{title && <h2>{title}</h2>}
				{subtext && <p className="subtext">{subtext}</p>}
				{cta && (
					<Button type="link" bg="white" to={cta.link}>
						{cta.text}
					</Button>
				)}
			</div>
		</HeroStyle>
	);
};
